import { render, staticRenderFns } from "./CmsContent.vue?vue&type=template&id=c8528484&"
import script from "./CmsContent.vue?vue&type=script&lang=js&"
export * from "./CmsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports